enum MethodPaymentTypes {
  cash = 'cash',
  newCard = 'new-card',
  mercadoPagoPoint = 'mercado-pago-point',
  clover = 'clover',
  balance = 'balance',
}

export default MethodPaymentTypes;
